import { render, staticRenderFns } from "./Line-Item-Detail-New.vue?vue&type=template&id=68e6a8a2"
import script from "./Line-Item-Detail-New.vue?vue&type=script&lang=js"
export * from "./Line-Item-Detail-New.vue?vue&type=script&lang=js"
import style0 from "./Line-Item-Detail-New.vue?vue&type=style&index=0&id=68e6a8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports